import { TranskodeVideoCodec } from "./transkode-video-codec";
import { OrderProductType } from "./order-product-type";

export enum SimpleOrderType {
  FileTranscode = "FileTranscode",
  FileDelivery = "FileDelivery",
}

export class CreateSimpleOrderRequest {
  type: SimpleOrderType | null = null;
  settings: TranscodeSimpleOrderSettings | FileDeliverySimpleOrderSettings | null = null;

  constructor(init?: Partial<CreateSimpleOrderRequest>) {
    Object.assign(this, init);
  }
}

class SimpleOrderSettings {
  $type: string = "VDM.AirLab.OrderService.Api.Models.SimpleOrderRequest.TranscodeSettings, VDM.AirLab.Sdk.Core";
  objectId: number | null = null;
  comment: string | null = null;
  recipientEmails: string[] = [];
  play: boolean = false;
}

export class TranscodeSimpleOrderSettings extends SimpleOrderSettings {
  proxy: boolean = true;
  codec: TranskodeVideoCodec = TranskodeVideoCodec.H264;
  frameIn?: number;
  frameOut?: number;
}

export class FileDeliverySimpleOrderSettings extends SimpleOrderSettings {
  proxy: boolean = true;
  storageId: number | null = null;
}
